let _ = require('lodash');

export class Snippet {
  /**
   * @type {string}
   */
  #appName;

  /**
   * @type {string}
   */
  shopHash = '';

  /**
   * @type {Object.<string, {}>}
   */
  products = {};

  /**
   * @type {number}
   */
  cacheTimestamp = 0;

  /**
   * @type {Object.<number, number>}
   */
  #variant2productCache = {};

  /**
   * @type {Object.<number, {id:number, title:string, inventory_quantity:number, inventory_management:string, inventory_policy:string}|null>}
   */
  #variantDetailsCache = {};

  /**
   * @param {string} appName
   */
  constructor(appName) {
    this.#appName = appName;
    this.fillFromSource();
  }

  /**
   *
   */
  fillFromSource() {
    let isSnippetSet = (
      typeof (Spurit) !== 'undefined' &&
      typeof (Spurit[this.#appName]) !== 'undefined' &&
      typeof (Spurit[this.#appName].snippet) !== 'undefined'
    );
    if (isSnippetSet) {
      let snippet = Spurit[this.#appName].snippet;
      for (let key in snippet) {
        if (snippet.hasOwnProperty(key)) {
          this[key] = snippet[key];
        }
      }
    }
  }

  /**
   * @param {number} variantId
   * @return {number|null}
   */
  getProductIdByVariantId(variantId) {
    if (typeof (this.#variant2productCache[variantId]) === 'undefined') {
      const product = Object.values(this.products).find(
        product => !!product.variants.find(variant => variant.id === variantId)
      );
      this.#variant2productCache[variantId] = product ? product.id : null;
    }
    return this.#variant2productCache[variantId];
  }

  /**
   * @param {number} variantId
   * @returns {{id:number, title:string, inventory_quantity:number, inventory_management:string, inventory_policy:string, price:number, compare_at_price:number}|null}
   */
  getVariantDetails(variantId) {
    if (typeof (this.#variantDetailsCache[variantId]) === 'undefined') {
      this.#variantDetailsCache[variantId] = null;
      Object.values(this.products).find(
        product => !!product.variants.find(variant => {
          if (variant.id === variantId) {
            this.#variantDetailsCache[variantId] = variant;
            return true;
          }
          return false;
        })
      );
    }
    return this.#variantDetailsCache[variantId];
  }
}